import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormSupportRequest} from '@shared-library';
import {FastenService} from '../../services/fasten.service';

@Component({
  selector: 'app-form-support-request',
  templateUrl: './form-support-request.component.html',
  styleUrls: ['./form-support-request.component.css'],
  standalone: false,
})
export class FormSupportRequestComponent implements OnInit {
  @Input() error?: string;
  @Input() error_description?: string;
  @Input() brand_id?: string;
  @Input() portal_id?: string;
  @Input() endpoint_id?: string;
  @Input() org_connection_id?: string;
  @Input() vault_profile_connection_id?: string;
  @Input() external_id?: string;
  @Input() external_state?: string;
  @Input() request_id?: string;

  formSupportRequest: FormSupportRequest = {} as FormSupportRequest;
  loading = false;
  submitSuccess = false;
  errorMsg = '';

  constructor(
    private router: Router,
    private fastenService: FastenService,
  ) {}

  ngOnInit(): void {
    this.resetForm();
  }

  resetForm(): void {
    this.submitSuccess = false;
    this.errorMsg = '';
    this.formSupportRequest = {
      email: '',
      healthsystem_name: '',
      request_content: '',
    } as FormSupportRequest;
  }

  submitForm(): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.errorMsg = '';

    this.formSupportRequest.error = this.error;
    this.formSupportRequest.error_description = this.error_description;
    this.formSupportRequest.brand_id = this.brand_id;
    this.formSupportRequest.portal_id = this.portal_id;
    this.formSupportRequest.endpoint_id = this.endpoint_id;
    this.formSupportRequest.org_connection_id = this.org_connection_id;
    this.formSupportRequest.vault_profile_connection_id = this.vault_profile_connection_id;
    this.formSupportRequest.external_id = this.external_id;
    this.formSupportRequest.external_state = this.external_state;
    this.formSupportRequest.request_id = this.request_id;

    this.fastenService.requestSupport(this.formSupportRequest).subscribe({
      next: () => {
        this.loading = false;
        this.submitSuccess = true;
      },
      error: (err) => {
        this.loading = false;
        this.errorMsg = this.getErrorMessage(err);
      }
    });
  }

  dismiss(): void {
    this.router.navigateByUrl('dashboard/accounts');
  }

  private getErrorMessage(err: any): string {
    const fallbackMessage = 'An error occurred while submitting your issue. Please try again later.';
    if (!err) {
      return fallbackMessage;
    }

    if (typeof err?.error === 'string' && err.error.length > 0) {
      return err.error;
    }

    if (typeof err?.error?.message === 'string' && err.error.message.length > 0) {
      return err.error.message;
    }

    if (typeof err?.message === 'string' && err.message.length > 0) {
      return err.message;
    }

    return fallbackMessage;
  }
}
